import React, { Component } from "react";
import { ModuleAccordionGroup } from '@loanbossinc/component-library';
import { AccordionSection } from "component-lib/AccordionSection";
import { rows as sectionBorrowerDocs } from './section-loan-borrower-docs-rows';
import { rows as sectionGuarantorDocs } from './section-loan-guarantor-docs-rows';
import { rows as sectionMiscellaneous } from './section-loan-misc-rows';
import { rows as sectionCashManagement } from './section-loan-cash-management-rows';
import { LOAN_SECTION_KEYS } from '../loan.constants';
import { findSummaryText } from '../loanDetailEditUtil';
const SHORTHAND_FIELD = "LoanFinancialReporting";

const nullData = {
  stylename: "Work Sans /  16 Regular",
    fontFamily: "Work Sans",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "19px",
    letterSpacing: "0em",
    textAlign: "center",
    textColor: "#7d8084"
};

const iconText = {
    fontSize: "12px",
    textColor: "#7d8084",
    margin: "10px"
};

export class LoanFinancialReporting extends Component {
  drawDataBorrowerDocs(data){
    if(data.covenants)
    {
      if(data.covenants.borrowerDeliveryPeriodMonthly ||
        data.covenants.borrowerListOfDocsMonthly ||
        data.covenants.borrowerDocsMonthlyReportingStart ||
        data.covenants.borrowerDeliveryPeriodQuarterly ||
        data.covenants.borrowerListOfDocsQuarterly ||
        data.covenants.borrowerDocsQuarterlyReportingStart ||
        data.covenants.borrowerDeliveryPeriodSemiAnnually ||
        data.covenants.borrowerListOfDocsSemiAnnually ||
        data.covenants.borrowerDocsSemiAnnuallyReportingStart ||
        data.covenants.borrowerDeliveryPeriodAnnually ||
        data.covenants.borrowerListOfDocsAnnually ||
        data.covenants.borrowerDocsAnnuallyReportingStart ||
        data.covenants.borrowerOfficerCertificate ||
        data.covenants.borrowerSignorId)
      {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionBorrowerDocs} data={data} />
      }
      else
      {
        return (<p style={nullData}>Data has not been entered for this section.</p>)
      };
    }
    else
    {
      return (<p style={nullData}>Data has not been entered for this section.</p>)
    };
  }
  
  drawDataGuarantorDocs(data){
    if(data.covenants)
    {
      if(data.covenants.guarantorDeliveryPeriodMonthly ||
        data.covenants.guarantorListOfDocsMonthly ||
        data.covenants.guarantorDocsMonthlyReportingStart ||
        data.covenants.guarantorDeliveryPeriodQuarterly ||
        data.covenants.guarantorListOfDocsQuarterly ||
        data.covenants.guarantorDocsQuarterlyReportingStart ||
        data.covenants.guarantorDeliveryPeriodSemiAnnually ||
        data.covenants.guarantorListOfDocsSemiAnnually ||
        data.covenants.guarantorDocsSemiAnnuallyReportingStart ||
        data.covenants.guarantorDeliveryPeriodAnnually ||
        data.covenants.guarantorListOfDocsAnnually ||
        data.covenants.guarantorDocsAnnuallyReportingStart ||
        data.covenants.guarantorOfficerCertificate ||
        data.covenants.guarantorSignor )
      {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionGuarantorDocs} data={data} />
      }
      else
      {
        return (<p style={nullData}>Data has not been entered for this section.</p>)
      };
    }
    else
    {
      return (<p style={nullData}>Data has not been entered for this section.</p>)
    };
  }
  
  drawDataMiscellaneous(data){
    if(data.covenants)
    {
      if(data.covenants.financialReportingMisc)
      {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionMiscellaneous} data={data} />
      }
      else
      {
        return (<p style={nullData}>Data has not been entered for this section.</p>)
      };
    }
    else
    {
      return (<p style={nullData}>Data has not been entered for this section.</p>)
    };
  }

  drawDataCashManagement(data){
    if(data.covenants)
    {
      if(data.covenants.cashManagementDeliveryPeriod||
        data.covenants.reportingStartDate||
        data.covenants.cashManagementListOfDocs||
        data.covenants.cashManagementReportingMisc||
        data.covenants.reportingWaiverStartDate||
        data.covenants.reportingWaiverEndDate)
      {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionCashManagement} data={data} />
      }
      else
      {
        return (<p style={nullData}>Data has not been entered for this section.</p>)
      };
    }
    else
    {
      return (<p style={nullData}>Data has not been entered for this section.</p>)
    };
  }

  getSubTitle = (data) => {
    const priorityHigh = data.covenants ? data.covenants.highPriority : null;
    if(priorityHigh)
    // {return "This loan is in cash management";}
    {return <React.Fragment><span class="material-icons" >error_outline</span> <span style={iconText}>{"This loan is in cash management"}</span></React.Fragment>  }
    else
    {return null;}
  }

  render() {
    const { data, history, loanId, enableEditButton, modifySummaryText, eventHandlers, ...other } = this.props;
    const summaryText = findSummaryText(data,SHORTHAND_FIELD);
    if (!data) return null;

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: 'Financial Reporting'
            , key: LOAN_SECTION_KEYS.FINANCIAL_REPORTING
            , isTitleGroup: true
            , isExpandable: false
            , buttonLabel: null
            , onClick: null
            , hasSummaryText: true
            , summaryText: summaryText
            , modifySummaryText: () => modifySummaryText(SHORTHAND_FIELD, summaryText)
          },
          {
            title: 'Borrower Docs'
            , key: LOAN_SECTION_KEYS.BORROWERDOCS
            , isExpandable: true
            , buttonLabel: 'Edit Details'
            , showEditButton: enableEditButton
            , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.BORROWERDOCS}`)
            , sections: [
              this.drawDataBorrowerDocs(data)
            ]
            , references: data.references
            , eventHandlers: eventHandlers
            , referencedFieldPath: "loans.covenants.borrowerDocs"
            , referenceStyles: { marginLeft: "20px" }
          },
          {
            title: 'Guarantor Docs'
            , key: LOAN_SECTION_KEYS.GUARANTORDOCS
            , isExpandable: true
            , buttonLabel: 'Edit Details'
            , showEditButton: enableEditButton
            , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.GUARANTORDOCS}`)
            , sections: [
              this.drawDataGuarantorDocs(data)
            ]
            , references: data.references
            , eventHandlers: eventHandlers
            , referencedFieldPath: "loans.covenants.guarantorDocs"
            , referenceStyles: { marginLeft: "20px" }
          },
          {
            title: 'Cash Management Reporting'
            , subTitle: this.getSubTitle(data)
            , key: LOAN_SECTION_KEYS.FINANCIAL_CASH_MANAGEMENT
            , isExpandable: true
            , buttonLabel: 'Edit Details'
            , showEditButton: enableEditButton
            , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.FINANCIAL_CASH_MANAGEMENT}`)
            , sections: [
              this.drawDataCashManagement(data)
            ]
            , references: data.references
            , eventHandlers: eventHandlers
            , referencedFieldPath: "loans.cashmanagementreporting.header"
            , referenceStyles: { marginLeft: "20px" }
          },
          {
            title: 'Miscellaneous'
            , key: LOAN_SECTION_KEYS.FINANCIALMISCELLANEOUS
            , isExpandable: true
            , buttonLabel: 'Edit Details'
            , showEditButton: enableEditButton
            , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.FINANCIALMISCELLANEOUS}`)
            , sections: [
              this.drawDataMiscellaneous(data)
            ]
            , references: data.references
            , eventHandlers: eventHandlers
            , referencedFieldPath: "loans.financialReportingMisc.header"
            , referenceStyles: { marginLeft: "20px" }
          },
        ]}
      />
    );
  }
}
